module.exports = __webpack_public_path__ + "static/media/MacPortrait2w300@2x.cd2c4c2d.jpg";